import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store";
import SuccessMessage from "Components/Basic/SuccessMessage";
import { Spinner } from "reactstrap";
// Assets and Static Datas
import failedAnimation from "assets/lottie/failed.json";
// Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
// config initializer import
import { initConfig } from "config/configInitializer";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Spinner
    size="sm"
    color="primary"
    className="position-absolute top-50 start-50"
  />
);

initConfig()
  .then(() => {
    root.render(
      <Provider store={store}>
        <React.StrictMode>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <App />
          </BrowserRouter>
        </React.StrictMode>
      </Provider>
    );
  })
  .catch((err) => {
    console.error("Config could not be loaded:", err);
    root.render(
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <SuccessMessage
          animation={failedAnimation}
          title="403 Access Denied"
          showDescription
          description="Failed to load config. Please try again later."
        />
      </div>
    );
  });
